<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right">
		  <el-breadcrumb-item>档案管理</el-breadcrumb-item>
		  <el-breadcrumb-item>采集方案</el-breadcrumb-item>
		</el-breadcrumb>

		<el-form inline label-width="76px" label-position="left">
		<!-- 	<el-form-item label="采集方案:">
				<el-input size="small" placeholder="请输入"></el-input>
			</el-form-item> -->
			<el-form-item >
        <!-- <el-button  @click="getData" icon="el-icon-search" type="primary" size="small">搜索</el-button> -->
				<el-button  icon="el-icon-circle-plus-outline" type="primary" @click="handelAdd"  size="small">添加</el-button>
			</el-form-item>
		</el-form>

		<el-table  size="small" border :data="dataList" v-loading="loading" height="600">

			<el-table-column type="index" label="序号"></el-table-column>
			<el-table-column prop="schemedesc" label="采集方案" ></el-table-column>
     <el-table-column prop="schemedesc" label="通信协议"  width="100">
       <template slot-scope="scope">
          <el-tag type="" size="mini" v-if="scope.row.protocolid == 20">南网</el-tag>
          <el-tag type="warning" size="mini" v-if="scope.row.protocolid == 10">国网</el-tag>
       </template>

     </el-table-column>
			<el-table-column align="center" label="操作" width="200">
				<template slot-scope="scope">
					<el-button size="mini" type="infor" @click="detail(scope.row)">详情</el-button>
					<el-button size="mini" type="danger" @click="handelDel(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>


    <el-dialog  title="新增采集方案" :visible.sync="addVisible" width="30%" :close-on-click-modal="false">
      <el-form label-width="100px"  :rules="rules" :model="addDataForm"  ref="aForm">
        <el-form-item label="方案名称：">
          <el-input v-model="addDataForm.schemedesc" size="small"  style="width: 215px;" ></el-input>
        </el-form-item>
        <el-form-item label="通信规约：" prop="protocolid">
         <el-select v-model="addDataForm.protocolid" size="small" placeholder="请选择"  >
             <el-option label="国网" value="10"></el-option>
             <el-option label="南网" value="20"></el-option>
           </el-select>
        </el-form-item>
      </el-form>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="mini" @click="addVisible = false">取 消</el-button>
    		<el-button size="mini" type="primary" :loading="saveLoad" @click="saveCollecionScheme">确 定</el-button>
    	</div>
    </el-dialog>

    <el-dialog  title="采集方案详情" :visible.sync="detailVisible" width="50%" :close-on-click-modal="false">
      <el-button type="primary" @click="handelAddDetail"  size="small" style="margin-bottom: 10px;">添加</el-button>
      <el-table :data="detailList" v-loading="loadDetail" border stripe size="small">
        <el-table-column label="数据项类型">
          <template slot-scope="scope">
            {{datatypeMap.get(scope.row.datatype)}}
          </template>
        </el-table-column>
        <el-table-column label="采集周期类型">
          <template slot-scope="scope">

            <el-tag v-if="scope.row.collectcyctype == 0" size="mini">分钟</el-tag>
            <el-tag v-if="scope.row.collectcyctype == 1" size="mini">小时</el-tag>
            <el-tag v-if="scope.row.collectcyctype == 2" size="mini">日</el-tag>
            <el-tag v-if="scope.row.collectcyctype == 3" size="mini">月</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="采集周期" prop="collectcyc"></el-table-column>
        <el-table-column label="最大采集周期数" prop="maxcollectcyc"></el-table-column>
        <el-table-column label="采集参考时间" prop="collectreftime"></el-table-column>
        <el-table-column align="center" label="操作" width="100">
        	<template slot-scope="scope">
        		<el-button size="mini" type="danger" @click="handelDetailDel(scope.row)">删除</el-button>
        	</template>
        </el-table-column>
      </el-table>

    	<div slot="footer" class="dialog-footer">
    		<el-button size="mini" @click="detailVisible = false">取 消</el-button>

    	</div>
    </el-dialog>

    <el-dialog  title="新增采集方案详情" :visible.sync="addDetaiVisible" width="35%" :close-on-click-modal="false" >
      <el-form label-width="140px"  :inline="true">
        <el-form-item label="数据项类型：">
          <el-select size="small" v-model="formData.datatype" placeholder="请选择" style="width:100%">
            <el-option v-for="item in dataTypes" :key="item.datatype" :label="item.datadesc":value="item.datatype"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="采集周期类型：">
          <el-select size="small" v-model="formData.collectcyctype" placeholder="请选择" style="width:100%">
            <el-option label="分钟" :value="0"></el-option>
            <el-option label="小时" :value="1"></el-option>
            <el-option label="日" :value="2"></el-option>
            <el-option label="月" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="采集周期：">
           <el-input v-model="formData.collectcyc"  type="number" size="small"></el-input>
        </el-form-item>
        <el-form-item label="采集参考时间：">
          <el-date-picker
            v-model="formData.collectreftime"
            type="datetime"
            size="small"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

      </el-form>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="mini" @click="addDetaiVisible = false">取 消</el-button>
    		<el-button size="mini" type="primary" :loading="saveLoad" @click="saveDetail">确 定</el-button>
    	</div>
    </el-dialog>



	</div>
</template>

<script>
  import {
    addDcsCollectscheme,
    getAllDcsCollectschemeList,
    delDcsCollectscheme,
    getSchemeDetail,
    getDataItems,
    addDcsCollectschemedetail,
    delDcsCollectschemedetail,
    } from '../../api/energyMG'
	export default{
    data(){
      return {
        loading:false,
        dataList:[],
        addVisible:false,
        detailVisible:false,
        saveLoad:false,
        addDetaiVisible:false,
        schemedesc:'',
        datatypeMap:new Map(),
        dataTypes:[],
        protocolId:'',
        loadDetail:false,
        schemeid:"",
        detailList:[],
        addDataForm:{
          schemedesc:'',
          protocolid:'',
        },

        formData:{
          schemeid:'',
          datatype:"",
          collectcyctype:"",
          collectreftime:new Date(),
          collectcyc:"",
          maxcollectcyc:1
        },
        rules:{
          protocolid :[
          	{ required: true, message: '请选择通信规约', trigger: 'change' },
          ],
        }
      }
    },
    created(){
      this.getData()
      this.getDataItem()
    },
    methods:{

      getData(){
        this.loading= true
        getAllDcsCollectschemeList().then(res => {
          this.loading= false
          if(res.status == 1){
            this.dataList = res.data
          }else{
            this.$message.error(res.msg)
          }
        })
      },



      handelAdd(){
        this.addVisible = true
      },

      saveCollecionScheme(){

        this.$refs['aForm'].validate( val =>{

          console.log(val)
          if(val){
            this.saveLoad = true

            addDcsCollectscheme(this.addDataForm).then(res => {
              this.saveLoad = false
              if(res.status == 1){
                 this.$message.success('操作成功！')
                 this.addVisible = false
                 this.addDataForm.protocolid = ''
                 this.getData()
              }else{
                 this.$message.error(res.msg)
              }
             })
          }      })



      },

      handelDel(row){
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delDcsCollectscheme({id:row.schemeid}).then(res => {
            if(res.status == 1){
              this.$message.success('操作成功！')
              this.getData()
            }else{
              this.$message.error(res.msg)
            }
          })
        }).catch(()=>{

        })
      },

      detail(row){

        this.detailVisible = true
        this.schemeid = row.schemeid

        this.protocolId = row.protocolid
        this.getDataItem().then(res => {
           this.getDetails()
        })


      },

      getDetails(){
        this.loadDetail = true
        getSchemeDetail({schemeid:this.schemeid}).then(res => {
          this.loadDetail = false
          if(res.status == 1){
            this.detailList = res.data
          }

        })
      },

      getDataItem(){
        return new Promise((resf,rej) => {
          getDataItems({protocolId:this.protocolId}).then(res => {
            if(res.status == 1){
              this.$nextTick( () => {
                res.data.forEach(item => {
                  this.datatypeMap.set(item.datatype,item.datadesc)
                })
                resf()
                this.dataTypes = res.data
              })

            }
          })
        })



      },

      handelAddDetail(){
        this.addDetaiVisible = true
        this.formData.schemeid = ''
        this.formData.datatype = ""
        this.formData.collectcyctype = ""
        this.formData.collectreftime = new Date()
        this.formData.collectcyc = ""
      },
      handelDetailDel(row){
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let param = {
            schemeid:row.schemeid,
            datatype:row.datatype
          }
          delDcsCollectschemedetail(param).then(res => {
            if(res.status == 1){
              this.$message.success('操作成功！')
              this.getDetails()
            }else{
              this.$message.error(res.msg)
            }
          })
        })
      },
      saveDetail(){
        this.formData.schemeid = this.schemeid
        addDcsCollectschemedetail(this.formData).then(res=> {
          if(res.status == 1){
            this.addDetaiVisible = false
            this.$message.success('操作成功！')
            this.getDetails()

          }else{
            this.$message.error(res.msg)
          }
        })
      },



    }


	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/archives/collectionScheme.vue